import React, { useState } from 'react'
import Input from './Input'
import { useDispatch } from 'react-redux'
import { CREATE_LESSON_PLAN } from '../redux/lessonPlansReducer'
import { useParams } from 'react-router-dom'

interface Props {
  toggleModal: () => void
}

const CreateLessonPlanModal = ({ toggleModal }: Props) => {
  const [name, setName] = useState<string | null>(null)
  const { unitId } = useParams()
  const dispatch = useDispatch()
  const createLessonPlan = () => {
    if (!name || !unitId) return
    toggleModal()
    dispatch(CREATE_LESSON_PLAN({ unitId: Number(unitId), name: name }))
  }

  return (
    <div>
      <div className="h-20" />
      <div className="bg-white rounded-md p-4 max-w-[27rem] w-screen">
        <h2 className="text-24 font-semibold">Create New Lesson Plan</h2>
        <div className="flex flex-col gap-4 mt-4">
          <Input
            label="Name"
            bgColor="white"
            color="darkIceBlue"
            value={name || ''}
            onChange={(e) => setName(e.target.value)}
          />
          <div className="flex justify-end mt-4">
            <button onClick={createLessonPlan} className="bg-slateGray px-4 py-2 rounded-md text-white font-semibold">
              Create
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CreateLessonPlanModal
